var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"hide-content"},_vm._l((_vm.postersContent),function(poster,index){return _c('div',{key:index,attrs:{"id":("canvas-" + (poster.id))},domProps:{"innerHTML":_vm._s(poster.content)}})}),0)}
var staticRenderFns = []
module.exports = { render: render, staticRenderFns: staticRenderFns }


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-6aec4684","hasScoped":true,"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./resources/assets/js/components/PostersContent.vue
// module id = VaEF
// module chunks = 101